<template>
  <div class="threejsContainer">
    <div class="containerTitle">1-11.粒子系统-改变</div>
    <div ref="container" class="containerBody"></div>
  </div>
</template>

<script>
import * as THREE from 'three';
import {generateScene} from '@/threejsEnv/scene.js';
import {OrbitControls} from 'three/examples/jsm/controls/OrbitControls.js';
import {generateShader} from './components/shader';

export default {
  data() {
    return {
      scene: null,
      camera: null,
      renderer: null,
      controls: null,
      currentMesh: null,
      fullPath: null,
      circleShape: null,
      progress: 0,
      u_time: 0,
      animationId: null
    };
  },
  mounted() {
    //初始化环境
    this.initEnv();
    //创建粒子系统
    this.createParticleSystem();
    // 启动动画
    this.animate();
    // 监听窗口大小变化
    window.addEventListener('resize', this.onWindowResize);
  },
  methods: {
    createParticleSystem() {
      //几何体
      const geometry = new THREE.CapsuleGeometry(2, 2,32,32);
      //获取几何体的坐标属性对象
      const positionAttribute = geometry.getAttribute('position');
      //顶点坐标
      const verticesArray = positionAttribute.array;
      //顶点对象数组
      const pointsGeometry = new THREE.BufferGeometry();
      pointsGeometry.setAttribute('position', new THREE.BufferAttribute(verticesArray, 3)); // 3个分量（x,y,z）

      
      const shaderMaterial = generateShader();
      console.log(shaderMaterial);

      const pointsMaterial = new THREE.PointsMaterial({
        color: 0xff0000, // 点的颜色（红色）
        size: 0.1, // 点的大小（根据场景比例调整）
        sizeAttenuation: true, // 点的大小是否随相机距离衰减（默认true，近大远小）
        transparent: true, // 开启透明（可选）
        opacity: 0.8 // 不透明度（可选）
      });
      console.log(pointsMaterial);
      
      // 4. 创建点对象并添加到场景
      this.particleSystem = new THREE.Points(pointsGeometry, shaderMaterial);

      this.scene.add(this.particleSystem);
    },
    animate() {
      this.animationId = requestAnimationFrame(this.animate);
      this.u_time+=0.05;
      this.particleSystem.material.uniforms.u_time.value = this.u_time;
      this.controls.update();
      this.renderer.render(this.scene, this.camera);
    },
    initEnv(){
      // 初始化场景
      this.scene = generateScene();
      this.scene.background = new THREE.Color(0xffffff);

      // 初始化相机
      this.camera = new THREE.PerspectiveCamera(
        75,
        this.$refs.container.clientWidth / this.$refs.container.clientHeight,
        0.1,
        1000
      );
      this.camera.position.set(0, 5, 10);

      // 初始化渲染器
      this.renderer = new THREE.WebGLRenderer({ antialias: true });
      this.renderer.setSize(
        this.$refs.container.clientWidth,
        this.$refs.container.clientHeight
      );
      this.$refs.container.appendChild(this.renderer.domElement);

      // 添加轨道控制器
      this.controls = new OrbitControls(this.camera, this.renderer.domElement);
      this.controls.enableDamping = true;

      // 创建光源
      const ambientLight = new THREE.AmbientLight(0xffffff, 0.5);
      this.scene.add(ambientLight);
      
      const directionalLight = new THREE.DirectionalLight(0xffffff, 0.8);
      directionalLight.position.set(10, 20, 15);
      this.scene.add(directionalLight);

      const gridHelper = new THREE.GridHelper(100, 100,
                                              0x666666,   // 中心轴线颜色（红色）
                                              0xcccccc    // 普通网格线颜色（绿色）
                                              ); // 10x10 网格
      this.scene.add(gridHelper);
    },
    onWindowResize() {
      const width = this.$refs.container.clientWidth;
      const height = this.$refs.container.clientHeight;

      // 更新相机
      this.camera.aspect = width / height;
      this.camera.updateProjectionMatrix();

      // 更新渲染器
      this.renderer.setSize(width, height);
    }
  },
  beforeDestroy() {
    // 清理动画和事件监听
    cancelAnimationFrame(this.animationId);
    window.removeEventListener('resize', this.onWindowResize);
    
    // 释放资源
    if (this.currentMesh) {
      this.scene.remove(this.currentMesh);
      this.currentMesh.geometry.dispose();
      this.currentMesh.material.dispose();
    }
    
    this.controls.dispose();
    this.renderer.dispose();
    this.renderer.domElement.remove();
  }
};
</script>

<style>
</style>
